export function getLogAudioBlobInfo(blob: Blob) {
  return {
    type: blob.type,
    size: blob.size,
  }
}
